<template>
	<div class="full" style="position: relative;" v-loading="loading">
		<v-jstree ref="jstree" text-field-name="name" value-field-name="id" :data="emuntree" :collapse="false"
			@item-click="itemClick" v-if="emuntree.length!=0"></v-jstree>
	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	import VJstree from 'vue-jstree'
	export default {
		name: 'report',
		props: {
			fundtype: {
				default: () => {
					return 'CD'
				}
			},
			bancktype: {
				default: () => {
					return ''
				}
			},
		},
		data() {
			return {
				loading:false,
				emuntree: []
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			this.loading = true
			this.$api.relation.listshop({plant:'wln'}).then((res)=>{
				this.loading = false
				this.emuntree = res.map((item)=>{
					return {id:item.shopUid,name:item.showName}
				})
			},()=>{
				this.loading = false
			})
		},
		computed: {

		},
		methods: {
			itemClick(node, item){
				this.$emit('change',item)
				// console.log(node, item)
			}
		},
		components: {
			VJstree
		}
	}
</script>